import { motion } from "framer-motion";
import { getCityImageUrl } from "../../lib/activityApi";

export default function CitySelector({ cities, selectedCityId, onSelect, baseUrl, countryName }) {
  if (!cities?.length) return null;

  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold text-[#222222] mb-4">
        Cities in {countryName || "this country"}
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {cities.map((city) => {
          const isSelected = selectedCityId === city._id;
          return (
            <motion.button
              key={city._id}
              type="button"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => onSelect(city)}
              className={`rounded-xl overflow-hidden shadow-md border-2 transition-all text-left ${
                isSelected ? "border-[#1ABCE3] ring-2 ring-[#1ABCE3]/30" : "border-transparent hover:shadow-lg"
              }`}
            >
              <div className="relative h-28 overflow-hidden">
                <img
                  src={getCityImageUrl(city.image, baseUrl)}
                  alt={city.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <span className="absolute bottom-2 left-2 right-2 text-white font-bold text-sm drop-shadow-lg">
                  {city.name}
                </span>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
